import type { AxiosInstance } from "axios"

export enum PropertiesQuery {
    PROPERTIES = "configuration-properties",
}

export type Properties = Readonly<{
    showResourceBookingModule?: boolean
    showRefillAccountModule?: boolean
    showCateringModule?: boolean
    showLunchModule?: boolean
    showLunchSubscriptionModule?: boolean
    showTakeAwayModule?: boolean
}>

// TODO: switch to a dedicated /web endpoint once backend exposes one.
// For now we reuse the mobile endpoint to get `showLunchModule` and
// `showLunchSubscriptionModule`
export async function fetchProperties({}, axios: AxiosInstance, signal?: AbortSignal): Promise<Properties> {
    const { data } = await axios.get<Properties>("/organization/company/configuration/properties/mobile", { signal })
    return data
}
